const KenyaSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111687)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#F0F0F0"
      />
      <path
        d="M20.0003 0C12.0711 0 5.21986 4.61445 1.98486 11.3044H38.0157C34.7808 4.61445 27.9295 0 20.0003 0Z"
        fill="black"
      />
      <path
        d="M20.0003 39.9997C12.0711 39.9997 5.21986 35.3852 1.98486 28.6953H38.0157C34.7808 35.3852 27.9295 39.9997 20.0003 39.9997Z"
        fill="#496E2D"
      />
      <path
        d="M39.0555 13.9131H0.944453C0.331797 15.8325 0 17.8775 0 20C0 22.1226 0.331797 24.1675 0.944453 26.087H39.0555C39.6682 24.1675 40 22.1226 40 20C40 17.8775 39.6682 15.8325 39.0555 13.9131Z"
        fill="#A2001D"
      />
      <path
        d="M26.2274 9.24262L23.8589 8.14941L19.9997 16.8878L16.1405 8.14941L13.772 9.24262L18.5632 20.0004L13.772 30.7581L16.1405 31.8513L19.9997 23.1129L23.8589 31.8513L26.2274 30.7581L21.4362 20.0004L26.2274 9.24262Z"
        fill="#F0F0F0"
      />
      <path
        d="M21.6085 10.2723C20.6916 9.27094 19.9998 8.69531 19.9998 8.69531C19.9998 8.69531 19.308 9.27086 18.3911 10.2723V29.727C19.308 30.7284 19.9998 31.3041 19.9998 31.3041C19.9998 31.3041 20.6916 30.7285 21.6085 29.727V10.2723Z"
        fill="#F0F0F0"
      />
      <path
        d="M15.6519 14.0032V25.9963C16.6208 27.7131 17.8066 29.1203 18.6954 30.0532V9.94629C17.8066 10.8792 16.6207 12.2864 15.6519 14.0032Z"
        fill="#A2001D"
      />
      <path
        d="M24.3472 14.0032C23.3782 12.2864 22.1925 10.8792 21.3037 9.94629V30.0532C22.1924 29.1203 23.3782 27.7131 24.3472 25.9963V14.0032Z"
        fill="#A2001D"
      />
      <path
        d="M24.3481 14.0039V25.997C25.329 24.2588 26.0873 22.2034 26.0873 20.0005C26.0873 17.7977 25.329 15.7422 24.3481 14.0039Z"
        fill="black"
      />
      <path
        d="M15.6522 14.0039V25.997C14.6714 24.2588 13.9131 22.2034 13.9131 20.0005C13.9131 17.7977 14.6714 15.7422 15.6522 14.0039Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111687">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default KenyaSvg;
